import {
  AdminInput,
  Button,
  Div,
  H3,
  Modal,
  P,
  PropsModal,
  Separator,
  StopVDriveLogo,
  cancelOrderVDrive,
  displayCentsInDollars,
  useOrders,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useState } from 'react';

export const CancelVDriveModal = ({
  id,
  cancelVDriveModal,
  closeModal,
  setData,
  setLoading,
  fee,
  isDriverAssigned,
}: PropsModal & {
  id: string;
  cancelVDriveModal: boolean;
  setData: Dispatch<SetStateAction<any>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  fee: number;
  isDriverAssigned: boolean;
}) => {
  const { changeVDriveOnList } = useOrders((state) => state);

  const [reason, setReason] = useState('');

  async function cancelVDrive(reason: string) {
    if (!id) return;

    try {
      setLoading(true);
      const { data } = await cancelOrderVDrive(id, reason);
      setData(data.data);
      changeVDriveOnList(id, data.data.vDrive || null);
      closeModal?.();
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={cancelVDriveModal}
      closeModal={closeModal}
      logo={false}
      zIndex={110}
    >
      <Div $flex $justifyCenter $mb="24">
        <StopVDriveLogo />
      </Div>
      <H3 $mb="8">Stop vDriver</H3>
      <P $mb="24">
        Are you sure you want to stop vDriver for this order?
        {!isDriverAssigned
          ? ` A processing fee of ${displayCentsInDollars(fee)} `
          : ` A driver is already assigned. The full delivery fee of ${displayCentsInDollars(
              fee
            )} `}
        has already been deducted and is non-refundable.
      </P>

      <Button
        $selected
        $w="100%"
        $mb="16"
        onClick={() => cancelVDrive('The restaurant delivered it themselves.')}
      >
        Yes, I Will Deliver Myself
      </Button>

      <Button
        $selected
        $gray
        $w="100%"
        onClick={() => cancelVDrive('The customer has already picked it up.')}
      >
        Customer Already Picked Up
      </Button>

      <Separator $m="16px 0" />

      <AdminInput
        type="textarea"
        value={reason}
        onChange={({ target }: { target: { value: string } }) =>
          setReason(target.value)
        }
        placeholder="Enter reason"
        label="Other"
        style={{ minHeight: 100, maxHeight: 100 }}
        $textCenter
      />

      <Button $selected $w="100%" $mt="24" onClick={() => cancelVDrive(reason)}>
        Confirm
      </Button>
    </Modal>
  );
};
